// extracted by mini-css-extract-plugin
export var divider = "_di-7";
export var itemsToggle = "_di-8";
export var mergeModal = "_di-1";
export var optionCard = "_di-4";
export var radioGroup = "_di-6";
export var radioOption = "_di-0";
export var selected = "_di-5";
export var shipmentOptions = "_di-2";
export var tableOptions = "_di-3";